/**
 * Team Grid Block JavaScript
 * Handles clickable headshots with expandable bio functionality
 */

document.addEventListener('DOMContentLoaded', function() {
	const teamGrids = document.querySelectorAll('.block-team-grid');
	
	teamGrids.forEach(function(grid) {
		const teamMembersContainer = grid.querySelector('.team-members');
		const imageButtons = grid.querySelectorAll('.team-member__image');
		let activeBioElement = null;
		
		// Calculate how many columns based on viewport
		function getColumnsPerRow() {
			const containerWidth = teamMembersContainer.offsetWidth;
			if (containerWidth <= 480) return 1;
			if (containerWidth <= 768) return 2;
			return 3;
		}
		
		// Find the last member in the same row
		function getLastMemberInRow(clickedMember) {
			const allMembers = Array.from(grid.querySelectorAll('.team-member'));
			const clickedIndex = allMembers.indexOf(clickedMember);
			const columns = getColumnsPerRow();
			const rowEndIndex = Math.floor(clickedIndex / columns) * columns + columns - 1;
			return allMembers[Math.min(rowEndIndex, allMembers.length - 1)];
		}
		
		imageButtons.forEach(function(button) {
			button.addEventListener('click', function(e) {
				e.preventDefault();
				
				const teamMember = this.closest('.team-member');
				const bioTemplate = teamMember.querySelector('.team-member__bio-template');
				
				if (!bioTemplate) return;
				
				const bioId = bioTemplate.id;
				
				// Check if clicking the same member
				const isSameMember = activeBioElement && activeBioElement.dataset.bioId === bioId;
				
				// Remove any existing bio
				if (activeBioElement) {
					activeBioElement.remove();
					activeBioElement = null;
					
					// Reset all buttons
					grid.querySelectorAll('.team-member__image[aria-expanded="true"]').forEach(function(btn) {
						btn.setAttribute('aria-expanded', 'false');
					});
				}
				
				// If clicking the same member, just close it
				if (isSameMember) {
					return;
				}
				
				// Create new bio element
				const bioWrapper = document.createElement('div');
				bioWrapper.className = 'team-member__bio';
				bioWrapper.dataset.bioId = bioId;
				bioWrapper.setAttribute('role', 'region');
				bioWrapper.setAttribute('aria-labelledby', teamMember.querySelector('.team-member__name').id || '');
				
				// Clone the template content
				const templateContent = bioTemplate.content.cloneNode(true);
				bioWrapper.appendChild(templateContent);
				
				// Find the last member in this row
				const lastMemberInRow = getLastMemberInRow(teamMember);
				
				// Insert bio after the last member in the row
				lastMemberInRow.after(bioWrapper);
				
				// Update aria-expanded
				this.setAttribute('aria-expanded', 'true');
				
				// Store reference
				activeBioElement = bioWrapper;
				
				// Add close button functionality
				const closeBtn = bioWrapper.querySelector('.team-member__bio-close');
				if (closeBtn) {
					closeBtn.addEventListener('click', function() {
						bioWrapper.remove();
						activeBioElement = null;
						button.setAttribute('aria-expanded', 'false');
					});
				}
				
				// Animate in
				setTimeout(function() {
					bioWrapper.classList.add('is-active');
					
					// Scroll to bio
					setTimeout(function() {
						bioWrapper.scrollIntoView({ 
							behavior: 'smooth', 
							block: 'nearest' 
						});
					}, 150);
				}, 10);
			});
		});
		
		// Handle window resize to reposition bio if needed
		let resizeTimer;
		window.addEventListener('resize', function() {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(function() {
				if (activeBioElement) {
					// Find the member that opened this bio
					const bioId = activeBioElement.dataset.bioId;
					const openMember = grid.querySelector('#' + bioId).closest('.team-member');
					const lastInRow = getLastMemberInRow(openMember);
					
					// Reposition if needed
					if (activeBioElement.previousElementSibling !== lastInRow) {
						activeBioElement.remove();
						lastInRow.after(activeBioElement);
					}
				}
			}, 250);
		});
	});
});

